// Mapping "portion de nom Airbnb" → id logement (source unique de vérité).
//
// Consommateurs :
//  - src/lib/csv-airbnb.js (import CSV Airbnb : AIRBNB_MAP + resolveListingId)
//  - src/components/CsvImportCibleBtn.jsx (resolveListingId)
// (L'ancien analyseur IA des courriels Airbnb a été retiré le 03/10 :
//  code mort, récupérable par l'étiquette git archive/code-mort-p4.)
//
// Format CommonJS pour être require-able par api/* (Node serverless) ET importable
// par App.jsx (CRA/webpack gère l'interop ESM→CJS). Placé dans src/lib/ parce que
// CRA interdit à src/ d'importer hors de src/ (ModuleScopePlugin).
//
// Ajouter un logement = ajouter UNE ligne ici ET dans fbz8-cfg côté app.
// Clé = forme canonique (lowercase, sans accents). Les consommateurs normalisent
// le nom reçu en entrée avant le .includes(key), donc inutile de dupliquer les
// variantes accentuées.

const AIRBNB_MAP = {
  'instant saint michel':     'l4',
  'ecrin toulousain':         'l1',
  'cocon toulousain':         'l5',
  'cachet toulousain':        'l6',
  'havre de bruguieres':      'l2',
  'charme de bruguieres':     'l3',
  'douce escapade':           'l7',
  'cocon naturel':            'lc1',
  'soleil du sud':            'lc2',
  'sur un nuage':             'lc3',
}

function normalizeListingName(name) {
  return String(name || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
}

function resolveListingId(listingName, map = AIRBNB_MAP) {
  const norm = normalizeListingName(listingName)
  if (!norm) return null
  for (const key of Object.keys(map)) {
    if (norm.includes(normalizeListingName(key))) return map[key]
  }
  return null
}

module.exports = { AIRBNB_MAP, normalizeListingName, resolveListingId }
